import { Nullable } from 'models/helpers'

/**
 * Blurred and original version of a photo count as one photo on Extended Blur orders.
 *
 * Pairs come from the backend (`blurredPairs` in the client gallery data): each visual mapped to its other version.
 * The frontend never derives pairs from filenames.
 */

/** Builds the pair lookup from the backend's `blurredPairs`, or an empty one when pair counting is off */
export const toBlurPartners = (blurredPairs: Nullable<Record<string, string>> | undefined, countPairsAsOne: boolean): Map<string, string> => {
  if (!countPairsAsOne || !blurredPairs) return new Map()
  return new Map(Object.entries(blurredPairs))
}

/** Key shared by both versions of a photo: the alphabetically first of the two names */
export const toPhotoKey = (name: string, partners: Map<string, string>): string => {
  const partner = partners.get(name)
  if (!partner) return name
  return partner < name ? partner : name
}

/** Number of photos among the given files, counting both versions of a paired photo once */
export const countPhotos = (names: Iterable<string>, partners: Map<string, string>): number => new Set([...names].map(name => toPhotoKey(name, partners))).size

/** The selection with the given file and the other version of its photo added (never removed) */
export const withVisualSelected = (selected: Set<string>, name: string, partners: Map<string, string>): Set<string> => new Set([...selected, ...withPartner(name, partners)])

/** The given file plus the other version of its photo, when it has one */
export const withPartner = (name: string, partners: Map<string, string>): string[] => {
  const partner = partners.get(name)
  return partner ? [name, partner] : [name]
}
